if ( typeof ProductVariants !== 'function' ) {

	class ProductVariants extends HTMLElement {

		constructor() {
			super();

			this._cachedOptions = new Map(); // Map for cached options with LRU eviction
			this._loadingOptions = new Set(); // Options currently being loaded
			this._debounceTimers = {}; // Debounce timers for mouseover events
			this._prefetchedUrls = new Set(); // Set to keep track of prefetched URLs
			this.observer = null; // IntersectionObserver instance
			this.CACHE_LIMIT = 100; // Cache limit

			this.init();

		}

		init() {

			if ( this.hasAttribute('data-enable-skeleton' ) ) {
				const skeleton = this.closest('.has-skeleton').querySelector('[data-js-product-item-skeleton]');
				this.skeletonElements = [...skeleton.querySelector('.product-item__text').children];
				this.skeletonSettings = JSON.parse(skeleton.querySelector('[data-product-skeleton-settings]').textContent);
			}

			this._event = new Event('VARIANT_CHANGE');

			this.productPage = this.closest('[data-js-product-component]');

			this.productForm = document.querySelector(`#product-form-${this.dataset.id}`);
			if ( this.productForm ) {
				this.productQty = this.productForm.querySelector('[data-js-product-quantity]');
				this.addToCart = this.productForm.querySelector('[data-js-product-add-to-cart]');
				this.addToCartText = this.productForm.querySelector('[data-js-product-add-to-cart-text]');
			}

			this.addEventListener('change', this.onOptionChange.bind(this));
			let initVariantChange = false;

			if ( this.hasAttribute('data-variant-required' ) ) {
				this.variantRequired = true;
				this.noVariantSelectedYet = true;
				this.fauxVariant = JSON.parse(this.querySelector('[data-js-variant-data]').textContent);
				if ( document.location.search.includes('variant') && this.hasAttribute('data-main-product-page-variants') ) {
					const initVariant = parseInt(new window.URLSearchParams(document.location.search).get('variant'));
					if ( initVariant ) {
						this.updateCurrentVariant();
						this.variantRequired = false;
						this.noVariantSelectedYet = false;
						initVariantChange = true;
						this.classList.add('variant-selected');
						this.productPage.classList.add('variant-selected');
						this.querySelectorAll('[data-option-value-id][data-selected]').forEach(elm=>{
							elm.tagName === 'OPTION' ? elm.setAttribute('selected', 'selected') : elm.setAttribute('checked', 'checked');
						});
					}
				} else {
					
					if ( this.getAttribute('data-unavailable-variants') !== 'hide' ) {
						this.querySelectorAll('[disabled]').forEach(elm=>{
							if ( ! elm.hasAttribute('data-disabled') ) {
								elm.removeAttribute('disabled')
							}
						});
						this.querySelectorAll('.disabled').forEach(elm=>{
							elm.classList.remove('disabled')
						});
					}

					this.querySelectorAll('[data-silent-selected]').forEach(elm=>{
						if ( elm.dataset.productUrl == this.dataset.url ) {
							elm.removeAttribute('data-silent-selected');
							elm.tagName === 'OPTION' ? elm.setAttribute('selected', 'selected') : elm.setAttribute('checked', 'checked');
							if ( parseInt(this.dataset.variants) == 1 ) {
								this.variantRequired = false;
								this.noVariantSelectedYet = false;
								this.classList.add('variant-selected');
								this.productPage.classList.add('variant-selected');
								initVariantChange = true;
							}
							this.checkIfSelectedVariant();
							this.updateCurrentVariant();
						}
					});
					const combination = [];
					this.querySelectorAll('[data-option-value-id][data-selected]').forEach(elm=>{
						combination.push(elm.dataset.optionValueId);
					});
					this.debounceOptionLoad(combination.join(',').replace(/,/g, '-'), 1);
				}
			} else {
				this.variantRequired = false;
				this.noVariantSelectedYet = false;
				this.classList.add('variant-selected');
				this.productPage.classList.add('variant-selected');
				this.updateCurrentVariant();
			}

			this.productStock = document.querySelector(`#product-${this.dataset.id} [data-js-variant-quantity]`);
			this.productStockProgress = document.querySelector(`#product-${this.dataset.id} [data-js-variant-quantity-progress]`);
			if ( this.productStock && document.querySelector(`#product-${this.dataset.id} [data-js-variant-quantity-data]`) ) {
				this.updateStock(JSON.parse(document.querySelector(`#product-${this.dataset.id} [data-js-variant-quantity-data]`).getAttribute('data-inventory')));
			}

			if ( initVariantChange ) {
				const combination = [];
				this.querySelectorAll('[data-option-value-id][data-selected]').forEach(elm => {
					combination.push(elm.dataset.optionValueId);
				});
				this.fetchProductUpdates(combination.join(',').replace(/,/g, '-'), this.renderProductUpdates.bind(this), false, true);
			}

			// preloading of option values

			const preloadOptionValues = () => {
				const combinations = this.getPossibleCombinations();
				combinations.forEach((combination) => {
					this.debounceOptionLoad(combination.join(',').replace(/,/g, '-'));
				});
				this.querySelectorAll('[data-product-url]').forEach(elm=>{
					this.prefetchPage(elm.dataset.productUrl);
				});
			};

			const IntersectionObserverCtor = window.IntersectionObserver;
			if (IntersectionObserverCtor) {
				new IntersectionObserverCtor((entries) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							preloadOptionValues();
						}
					});
				}, {
					rootMargin: '0px',
					threshold: 0.1,
				}).observe(this);
			} else {
				preloadOptionValues();
			}

			new MutationObserver(() => {
				const combinations = this.getPossibleCombinations();
				combinations.forEach((combination) => {
					this.debounceOptionLoad(combination.join(',').replace(/,/g, '-'));
				});
				this.querySelectorAll('[data-product-url]').forEach(elm=>{
					this.prefetchPage(elm.dataset.productUrl);
				})
			}).observe(this.querySelector('[data-js-variant-data]'), {
				attributes: false, childList: true, subtree: false
			});

			this.addEventListeners();

		}

		addEventListeners() {

			this.querySelectorAll('[data-option-value-id]').forEach((elm) => {
				
				elm.addEventListener('mouseover', (e) => {
					e.stopPropagation();
					const combination = this.getSpecificCombinations(e.target, e.target.closest('[data-js-product-variant-container]'));
					if ( ! e.target.hasAttribute('data-selected') && ! e.target.hasAttribute('data-product-url') ) {
						this.debounceOptionLoad(combination.join(',').replace(/,/g, '-'), 1);
					} else if ( e.target.hasAttribute('data-custom-product-url' ) ) {
						this.debounceOptionLoad(combination.join(',').replace(/,/g, '-'), 1, e.target.getAttribute('data-custom-product-url'));
					}	
				});
	
				elm.addEventListener('touchstart', e => {
					e.stopPropagation(); 
					const combination = this.getSpecificCombinations(e.target, e.target.closest('[data-js-product-variant-container]'));
					if ( ! e.target.hasAttribute('data-selected') && ! e.target.hasAttribute('data-product-url') ) {
						this.debounceOptionLoad(combination.join(',').replace(/,/g, '-'), 1);
					} else if ( e.target.hasAttribute('data-custom-product-url' ) ) {
						this.debounceOptionLoad(combination.join(',').replace(/,/g, '-'), 1, e.target.getAttribute('data-custom-product-url'));
					}	
				}, { passive:true });
			});

		}

		debounceOptionLoad(optionValuesHash, delay = 20) {
			// Debounce function to prevent multiple quick fetches
			if (this._debounceTimers[optionValuesHash]) {
				clearTimeout(this._debounceTimers[optionValuesHash]);
			}
			this._debounceTimers[optionValuesHash] = setTimeout(() => {
				if (!this._cachedOptions.has(optionValuesHash) && !this._loadingOptions.has(optionValuesHash)) {
					this.preloadOption(optionValuesHash);
				}
			}, delay);
		}

		preloadOption(optionValuesHash) {
			// Preload a single option
			this._loadingOptions.add(optionValuesHash);
			this.fetchProductUpdates(optionValuesHash, (html) => {
				this.cacheProductUpdates(html, optionValuesHash);
				this._loadingOptions.delete(optionValuesHash);
			});
		}
	
		prefetchPage(url) {
			// Prefetch the page using a link element
			if ( ! this._prefetchedUrls.has(url) && url !== window.location.pathname ) {
				const link = document.createElement('link');
				link.rel = 'prefetch';
				link.href = url;
				document.head.appendChild(link);
				this._prefetchedUrls.add(url);
			}
		}

		getSelectedOptionHash(){ 
			return [...this.querySelectorAll('select[data-js-product-variant-container], input:checked')]
				.map(el => el.dataset.optionValueId || el.selectedOptions[0]?.dataset.optionValueId)
				.filter(value => value !== undefined)
				.join(',').replace(/,/g, '-');
		}

		getPossibleCombinations() {
	
			const currentSelections = [];
			const options = [];
	
			this.querySelectorAll('[data-js-product-variant-container]').forEach(row => {
				const rowOptions = [];
				let currentSelection = null;

				row.querySelectorAll('[data-option-value-id]').forEach(option => {
					rowOptions.push(option.getAttribute('data-option-value-id'));
					if (option.hasAttribute('data-selected')) {
						currentSelection = option.getAttribute('data-option-value-id');
					}
				});
		
				if (currentSelection === null) {
					//console.error('No selected option found in one of the rows');
					return;
				}
		
				options.push(rowOptions);
				currentSelections.push(currentSelection);
			});
		
			function generatePossibleCombinations(currentSelections, options) {
				const possibleCombinations = [];
		
				for (let i = 0; i < currentSelections.length; i++) {
					const newCombination = [...currentSelections];
					options[i].forEach((option) => {
						if ( option !== currentSelections[i] && ! this.querySelector(`[data-option-value-id="${option}"]`).hasAttribute('data-product-url') ) {
							newCombination[i] = option;
							possibleCombinations.push([...newCombination]);
						}
					});
				}
				return possibleCombinations;
			}
		
			return generatePossibleCombinations.call(this, currentSelections, options);
		}

		getSpecificCombinations(hoveredOption, hoveredRow) {
			const newCombination = [];
			this.querySelectorAll('[data-js-product-variant-container]').forEach(row => {
				if ( row === hoveredRow ) {
					newCombination.push(hoveredOption.dataset.optionValueId);
				} else {
					newCombination.push(row.querySelector('[data-selected]').dataset.optionValueId);
				}
			});
			return newCombination;
		}

		async fetchProductUpdates(optionValuesHash, callback, checkHash = false, force = false, priority = 'auto') {
			// turn from hash to no hash
			// Fetch product updates
			try {
				const response = await fetch(`${this.dataset.url}${this.dataset.url.includes('?') ? '&' : '?'}section_id=${this.dataset.helperId}&option_values=${optionValuesHash.replace(/-/g, ',')}`, {prioirty: priority});
				const responseText = await response.text();
				const html = new DOMParser().parseFromString(responseText, 'text/html');
				if ( optionValuesHash === this.currentOptionValueHash || checkHash === false || force ) {
					callback(html, optionValuesHash);
				}
			} catch (error) {
				console.error(`Error fetching options ${optionValuesHash}:`, error);
				this._loadingOptions.delete(optionValuesHash);
			}
		}

		async fetchAndReloadProductItem(url, productItem) {

			productItem.classList.add('loading');

			try {

				const response = await fetch(`${url}${url.includes('?') ? '&' : '?'}section_id=helper-product-item`);	
				let responseText = await response.text();
				const responseId = `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
				responseText = responseText.replaceAll(/UNIQUE_ID/g, responseId);

				const html = new DOMParser().parseFromString(responseText, 'text/html');
				KROWN.productItemUpdateHelper(productItem, responseId, html, {elements: this.skeletonElements, settings: this.skeletonSettings});
				productItem.classList.remove('loading');

				productItem.dispatchEvent(new Event('reload', { bubbles: true }));

			} catch (error) {
				console.error(`Error`, error); 
				productItem.classList.remove('loading');
			}
		}		
		
		async fetchAndReloadProductPage(url, productPage) {

			productPage.classList.add('loading');

			try {
				const response = await fetch(`${url}${url.includes('?') ? '&' : '?'}view=quick-view`);	
				let responseText = await response.text();
				const quickViewHTML = new DOMParser().parseFromString(responseText, 'text/html').querySelector('#product-quick-view');
				productPage.innerHTML = quickViewHTML.innerHTML;
				productPage.classList.remove('loading');
				productPage.dispatchEvent(new Event('reload', { bubbles: true }));
			} catch (error) {
				console.error(`Error`, error); 
				productPage.classList.remove('loading');
			}
		}

		cacheProductUpdates(html, optionValuesHash) {
			// Cache the fetched HTML with LRU eviction
			if (this._cachedOptions.size >= this.CACHE_LIMIT) {
				// Remove the oldest item (first entry in the Map)
				const oldestKey = this._cachedOptions.keys().next().value;
				this._cachedOptions.delete(oldestKey);
			}
	
			// Add the new item
			this._cachedOptions.set(optionValuesHash, html);
			// Ensure the most recently accessed item is moved to the end of the Map
			this._updateCacheOrder(optionValuesHash);
		}

		_updateCacheOrder(optionValuesHash) {
			// Move the accessed item to the end to mark it as recently used
			const value = this._cachedOptions.get(optionValuesHash);
			this._cachedOptions.delete(optionValuesHash);
			this._cachedOptions.set(optionValuesHash, value);
		}


		onOptionChange(e) {
			const variant = e.target;
			const isSelectElement = !!(window.HTMLSelectElement && variant instanceof window.HTMLSelectElement);
			const targetUrl = isSelectElement ? variant.selectedOptions[0].dataset.productUrl : variant.dataset.productUrl;
			const variantId = isSelectElement ? variant.selectedOptions[0].dataset.variantId : variant.dataset.variantId
			const optionValuesHash = this.getSelectedOptionHash();
			this.currentOptionValueHash = optionValuesHash;
			this.addEventListeners();

			if ( targetUrl !== '' && targetUrl !== undefined && targetUrl !== this.dataset.url ) {
				if ( variant.hasAttribute('data-product-custom-url') || ( isSelectElement && variant.selectedOptions[0].hasAttribute('data-product-custom-url') ) ) {
					if ( variant.dataset.productCustomUrl == 'product' ) {
						this.fetchAndReloadProductItem(targetUrl, variant.closest('[data-js-product-item]'));
					} else {
						this.fetchAndReloadProductPage(targetUrl, variant.closest('[data-js-product-page]'));
					}
				} else {
					window.location.assign(targetUrl);
				}

			} else {

				if ( this.variantRequired && this.noVariantSelectedYet ) {
					this.checkIfSelectedVariant();
				}
				
				if ( this.noVariantSelectedYet == false ) {
					if (this._cachedOptions.has(optionValuesHash)) {
						// Use cached content if available
						this.renderProductUpdates(this._cachedOptions.get(optionValuesHash));
						this._updateCacheOrder(optionValuesHash);
					} else {
						// Fetch updates if not cached
						this.fetchProductUpdates(optionValuesHash, this.renderProductUpdates.bind(this), true, false, 'high');
					}
					this.updateURL(variantId);

				}

			}

		}

		renderProductUpdates(html) {

			// update variant specific blocks
			html.querySelectorAll('[data-update-block]').forEach(elm=>{
				if ( ! elm.hasAttribute('data-update-block-inner') ) {
					// A block present in the fetched section but absent on the live page
					// must not abort the render — VARIANT_CHANGE would never dispatch.
					const target = this.productPage.querySelector(`[data-update-block="${elm.dataset.updateBlock}"]`);
					if ( target ) target.innerHTML = elm.innerHTML;
				}
			});

			// update product id (selected variant)
			this.productPage.querySelectorAll('input[name="id"]').forEach(elm=>{
				if ( elm.closest('[data-js-product-component]') === this.productPage ) {
					elm.value = html.querySelector('input[name="id"]').value;
				}
			});
			
			// update current variant and available options
			this.updateCurrentVariant();
			this.updateOptions(html.querySelectorAll('[data-main-product-variants] [data-option-value-id]'));

			// handle stock related updates
			if ( this.productStock && html.querySelector('[data-js-variant-quantity-data]' ) ) {
				this.updateStock(JSON.parse(html.querySelector('[data-js-variant-quantity-data]').getAttribute('data-inventory')));
			}
			this.updateOutOfStockVariants();
			this.updateBuyButtons();
		
			this.dispatchEvent(this._event);

		}

		updateOptions(optionsData) {

			optionsData.forEach(option => {
				
				const optionElm = this.querySelector(`[data-option-value-id="${option.dataset.optionValueId}"]`);

				optionElm.setAttribute('data-available', option.dataset.available);
				optionElm.setAttribute('data-variant-id', option.dataset.variantId);
				if ( option.hasAttribute('data-product-url') != '' ) {
					optionElm.setAttribute('data-product-url', option.dataset.productUrl);
				} else {
					optionElm.removeAttribute('data-product-url');
				}
				const isOptionElement = !!(window.HTMLOptionElement && optionElm instanceof window.HTMLOptionElement);
				if ( option.hasAttribute('data-selected') ) {
					optionElm.setAttribute('data-selected', '');
					optionElm.setAttribute(`${isOptionElement ? 'selected' : 'checked'}`, '');
				} else {
					optionElm.removeAttribute('data-selected');
					optionElm.removeAttribute(`${isOptionElement ? 'selected' : 'checked'}`, '');
				}

				if ( this.dataset.unavailableVariants != 'show' && option.dataset.available == 'false' && ! ( optionElm.hasAttribute('data-product-url') ) ) {
					optionElm.setAttribute('disabled', 'disabled');
				} else {
					if ( ! optionElm.hasAttribute('data-disabled') ) {
						optionElm.removeAttribute('disabled');
					}
				}

				if ( option.dataset.available == 'true' ) {
					if ( !isOptionElement ) {
						optionElm.classList.remove('disabled');
						optionElm.closest('.product-variant__item').classList.remove('disabled');
					}
				} else {
					if ( ! (optionElm.hasAttribute('data-product-url') ) ) {
						if ( !isOptionElement ) {
							optionElm.classList.add('disabled');
							optionElm.closest('.product-variant__item').classList.add('disabled');
						}
					}
				}

			});

		}

		updateBuyButtons(){
			if ( this.productForm ) {
				const preorderEnabled = this.addToCartText.hasAttribute('data-show-preorder-wording');
				if ( ( ! this.currentVariant || ! this.currentVariant.available ) && ! preorderEnabled ) {
					if ( this.productQty ) this.productQty.style.display = 'none';
					this.addToCart.classList.add('disabled');
					this.productForm.classList.add('disabled-cart');
					this.addToCartText.textContent = KROWN.settings.locales.products_sold_out_variant;
				} else {
					if ( this.productQty ) this.productQty.style.display = '';
					this.addToCart.classList.remove('disabled');
					this.productForm.classList.remove('disabled-cart');
					this.addToCartText.textContent = this.hasAttribute('data-show-bundle-wording') ? KROWN.settings.locales.products_add_to_bundle_button : preorderEnabled ? KROWN.settings.locales.products_preorder_button : KROWN.settings.locales.products_add_to_cart_button;
				}
				if ( ! this.currentVariant ) {
					this.productForm.classList.add('unavailable-variant');
					this.addToCartText.textContent = (this.variantRequired && this.noVariantSelectedYet) ? KROWN.settings.locales.products_variant_required : KROWN.settings.locales.products_unavailable_variant;
				} else {
					this.productForm.classList.remove('unavailable-variant');
				}
			}
		}

		updateCurrentVariant(){
			this.currentVariant = JSON.parse(this.querySelector('[data-js-variant-data]').textContent);
			if ( this.currentVariant == null ) {
				this.currentVariant = false;
			}
		}

		updateStock(productStockData){

			if ( this.productStock ) {

				if ( ! this.currentVariant) {
					if ( this.productStock ) {
						this.productStock.innerHTML = '';
					}
				} else {


					if ( this.productStock && productStockData[0] ) {

						let currentVariant = productStockData[0];
						
						this.productStock.innerHTML = '';

						if ( currentVariant ) {

							if ( currentVariant.quantity <= 0 ) {
								if ( currentVariant.inventory == 'continue' ) {
									this.productStock.innerHTML = KROWN.settings.locales.products_preorder;
									this.productStock.setAttribute('data-stock', 'pre-order');
								} else if ( currentVariant.inventory == 'deny' ) {
									this.productStock.innerHTML = KROWN.settings.locales.products_no_products;
									this.productStock.setAttribute('data-stock', 'out-of-stock');
								}
							} else if ( currentVariant.quantity == '1' ) {
								this.productStock.innerHTML = KROWN.settings.locales.products_one_product;
								this.productStock.setAttribute('data-stock', 'one-item-stock');
							} else if ( currentVariant.quantity <= parseInt(this.productStock.dataset.lowStock) ) {
								this.productStock.innerHTML = KROWN.settings.locales.products_few_products.replace('{{ count }}', currentVariant.quantity);
								this.productStock.setAttribute('data-stock', 'little-stock');
							} else if ( currentVariant.unavailable ) {
								this.productStock.innerHTML = KROWN.settings.locales.products_no_products;
								this.productStock.setAttribute('data-stock', 'out-of-stock');
							} else if ( currentVariant.quantity > parseInt(this.productStock.dataset.lowStock) && this.productStock.dataset.type == "always" ) {
								this.productStock.innerHTML = KROWN.settings.locales.products_many_products.replace('{{ count }}', currentVariant.quantity);
								this.productStock.setAttribute('data-stock', 'in-stock');
							} else if ( ! currentVariant.quantity && this.productStock.dataset.type == "always" )  {
								this.productStock.innerHTML = KROWN.settings.locales.products_enough_products;
								this.productStock.setAttribute('data-stock', 'in-stock');
							}

							if ( this.productStockProgress ) {
								let progressQty = 0;
								if ( currentVariant.quantity <= 0 && currentVariant.inventory == 'continue' || typeof currentVariant.quantity === 'undefined' ) {
									progressQty = parseInt(this.productStock.dataset.highStock);
								} else if ( currentVariant.quantity > 0 ) {
									progressQty = currentVariant.quantity;
								}
								if ( progressQty >= parseInt(this.productStock.dataset.highStock)  ) {
									this.productStockProgress.style.width = `100%`;
								} else {
									this.productStockProgress.style.width = `${100 * progressQty / parseInt(this.productStock.dataset.highStock)}%`;
								}
							}

						}
					}
				}
			}
		}

		updateOutOfStockVariants() {

			// Check if all the variants in a group are disabled, show an "out of stock" message

			this.querySelectorAll('[data-js-product-variant]').forEach(variant=>{
				let allDisabled = true;
				variant.classList.remove('product-variant--all-disabled');
				variant.querySelector('.product-variant__out-of-stock')?.classList.add('hide');
				variant.querySelector('.product-variant__out-of-stock')?.setAttribute('aria-hidden', 'true');
				variant.querySelectorAll('.product-variant-value').forEach(variantInput=>{
					if ( ! ( variantInput.hasAttribute('disabled') || variantInput.classList.contains('disabled') ) ) {
						allDisabled = false;
					}
				});
				if ( allDisabled ) {
					variant.classList.add('product-variant--all-disabled');
					variant.querySelector('.product-variant__out-of-stock')?.classList.remove('hide');
					variant.querySelector('.product-variant__out-of-stock')?.removeAttribute('aria-hidden');
				}	
			});

		}

		updateURL(variantId = '') {
			if (!this.hasAttribute('data-no-history') && variantId !== '') {
				window.history.replaceState({}, '', `${this.dataset.url}?variant=${variantId}`);
			}
		}

		checkIfSelectedVariant(){

			this.options = [];
			this.querySelectorAll('[data-js-product-variant-container]').forEach(elm=>{
				if ( elm.dataset.jsProductVariantContainer == 'radio' ) {
					elm.querySelectorAll('.product-variant__input').forEach(el=>{
						if ( el.checked ) {
							this.options.push(el.value);
						}
					});
				} else {
					if ( ! ( this.variantRequired && elm.selectedIndex == 0 ) ) {
						this.options.push(elm.value);
					}
				}
			});
			if ( this.variantRequired && this.noVariantSelectedYet && this.options.length >= parseInt(this.dataset.variants) ) {
				this.noVariantSelectedYet = false;
				this.classList.add('variant-selected');
				this.productPage.classList.add('variant-selected');
			}

		}

	}


  if ( typeof customElements.get('product-variants') == 'undefined' ) {
		customElements.define('product-variants', ProductVariants);
	}

}

/* ---
	Product Form
--- */

if ( typeof ProductForm !== 'function' ) {

	class ProductForm extends HTMLElement {
		constructor() {
			super();   
			this.init();
		}

		init(){
			this.productPage = this.closest('[data-js-product-component]');
			this.isSubmitting = false;
			this.cartType = this.hasAttribute('data-ajax-cart') ? ( KROWN.settings.cart_action == 'popup' ? 'popup' : 'ajax' ) : 'page';
			if ( ! document.body.classList.contains('template-cart') || this.hasAttribute('data-force-form' ) ) {
				this.form = this.querySelector('form');
				this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
				this.ADD_TO_CART = new Event('add-to-cart');
			}
			if ( document.body.classList.contains('touchevents') ) {
				const submitButton = this.querySelector('[type="submit"]');
				if ( submitButton ) {
					submitButton.addEventListener('touchend', _e=>{
						//submitButton.click();
					});
				}
			}
		}

		async onSubmitHandler(e) {

			e.preventDefault();
			if ( this.isSubmitting ) return false;

			// The sticky bar delegates by calling the primary button's .click(), which
			// dispatches this same submit synchronously in the same call stack — so a
			// flag set on the shared product-page container right before that call is
			// still there to read here, before anything async can race it.
			const relatedItemsSource = this.productPage?.dataset.atcSource === 'sticky' ? 'sticky' : 'primary';
			if ( this.productPage ) delete this.productPage.dataset.atcSource;

			const submitButton = this.querySelector('[type="submit"]');
			this.isSubmitting = true;
			submitButton.classList.add('working');

			let customPropertiesRequired = false;

			if ( this.productPage ) {
				this.productPage.querySelectorAll('[data-js-custom-property]').forEach(elm=>{
					if ( elm.querySelector('[required]') ) {

						if ( elm.classList.contains('product-variants--text' ) ) {
							const txtInputElm = elm.querySelector('input') || elm.querySelector('textarea');
							if ( txtInputElm.value == '' ) {
								customPropertiesRequired = true;
								txtInputElm.focus();
								elm.querySelector('.product-variant__required').style.display = 'block';
							}
						} else if ( elm.classList.contains('product-variants--select' ) ) {
							if ( elm.querySelector('select').value == '' ) {
								customPropertiesRequired = true;
								elm.querySelector('select').focus();
								elm.querySelector('.product-variant__required').style.display = 'block';
							}
						} else if ( elm.classList.contains('product-variants--checkbox' ) ) {
							if ( ! elm.querySelector('input:checked') ) {
								customPropertiesRequired = true;
								elm.querySelector('input').focus();
								elm.querySelector('.product-variant__required').style.display = 'block';
							}
						}

						elm.addEventListener('click', ()=>{
							elm.querySelector('.product-variant__required').style.display = 'none';
						});

					}
				});
			}

			if ( customPropertiesRequired ) {
				submitButton.classList.remove('working');
				this.isSubmitting = false;
				return false;
			}

			const relatedProducts = this.productPage?.querySelector('product-related');
			const selectedRelatedProducts = typeof relatedProducts?.getSelectedItems === 'function' ? relatedProducts.getSelectedItems() : [];
			const primaryItem = this.getPrimaryItem();

			try {
				const request = this.buildCartRequest(primaryItem, selectedRelatedProducts);
				const cartResponse = await fetch(`${KROWN.settings.routes.cart_add_url}.js`, request);
				let cartData;
				try {
					cartData = await cartResponse.json();
				} catch (_error) {
					throw new Error('Unable to read the cart response');
				}

				if ( ! cartResponse.ok || cartData.status == 422 ) {
					// Shopify may have adjusted an over-requested quantity, so reconcile every cart
					// type before reporting. Even the 'page' cart refreshes the header count/total.
					try {
						await this.refreshCart(primaryItem);
					} catch (_error) {
						// The original cart error is more useful than a refresh failure.
					}
					this.showCartError(cartData.description || cartData.message);
					return false;
				}

				if ( selectedRelatedProducts.length ) {
					const relatedAddDetail = {
						primaryVariantId: primaryItem.id,
						products: selectedRelatedProducts,
						source: relatedItemsSource
					};
					this.dispatchEvent(new CustomEvent('pdp-product-related-add', {
						bubbles: true,
						detail: relatedAddDetail
					}));
					this.publishAnalytics('pdp_related_add', relatedAddDetail);
				}

				if ( this.cartType == 'page' ) {
					this.dispatchEvent(this.ADD_TO_CART);
					document.location.href = KROWN.settings.routes.cart_url;
					return false;
				}

				// Listeners (drawer progress bar, free-gift accordion) read the refreshed
				// #AjaxCartSubtotal, so the event fires after refreshCart. It still fires if
				// the refresh fails: the item is in the cart and the drawer must open.
				try {
					await this.refreshCart(primaryItem);
				} finally {
					this.dispatchEvent(this.ADD_TO_CART);
				}
				this.announceCartUpdate();
			} catch (_error) {
				this.showCartError(KROWN.settings.locales.cart_general_error);
			} finally {
				submitButton.classList.remove('working');
				this.isSubmitting = false;
			}
		}

		getPrimaryItem() {
			const item = { properties: {} };
			new FormData(this.form).forEach((value, key) => {
				if ( key == 'id' ) {
					item.id = value;
				} else if ( key == 'quantity' ) {
					item.quantity = Number(value) || 1;
				} else if ( key == 'selling_plan' ) {
					item.selling_plan = value;
				} else if ( key.indexOf('properties[') === 0 && key.endsWith(']') ) {
					item.properties[key.slice(11, -1)] = value;
				}
			});
			if ( ! Object.keys(item.properties).length ) delete item.properties;
			if ( ! item.quantity ) item.quantity = 1;
			return item;
		}

		cartRequestHeaders(contentType) {
			return { 'Content-Type': contentType, 'X-Requested-With': 'XMLHttpRequest' };
		}

		buildCartRequest(primaryItem, selectedRelatedProducts) {
			if ( ! selectedRelatedProducts.length ) {
				return {
					body: this._serializeForm(this.form),
					headers: this.cartRequestHeaders('application/x-www-form-urlencoded'),
					method: 'POST'
				};
			}
			return {
				body: JSON.stringify({ items: [primaryItem, ...selectedRelatedProducts.map(({ id, quantity }) => ({ id, quantity }))] }),
				headers: this.cartRequestHeaders('application/json'),
				method: 'POST'
			};
		}

		async refreshCart(primaryItem) {
			const response = this.cartType == 'popup'
				? await fetch(`${this.dataset.productUrl}?variant=${(primaryItem || this.getPrimaryItem()).id}&section_id=helper-cart-popup`)
				: await fetch('?section_id=helper-cart');
			const sectionInnerHTML = new DOMParser().parseFromString(await response.text(), 'text/html');

			if ( this.cartType == 'ajax' && document.getElementById('AjaxCartForm') ) {
				const cartForm = sectionInnerHTML.getElementById('AjaxCartForm');
				const cartSubtotal = sectionInnerHTML.getElementById('AjaxCartSubtotal');
				if ( cartForm && cartSubtotal ) {
					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartForm.innerHTML;
					cartItems.ajaxifyCartItems?.();
					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotal.innerHTML;
				}
			} else if ( this.cartType == 'popup' && document.querySelector('[data-js-site-cart-popup-content]') ) {
				const popup = sectionInnerHTML.querySelector('.shopify-section');
				if ( popup ) document.querySelector('[data-js-site-cart-popup-content]').innerHTML = popup.innerHTML;
			}

			document.querySelectorAll('[data-header-cart-count]').forEach(elm => {
				const count = sectionInnerHTML.querySelector('[data-cart-count]');
				if ( count ) elm.textContent = count.textContent;
			});
			document.querySelectorAll('[data-header-cart-total]').forEach(elm => {
				const total = sectionInnerHTML.querySelector('[data-cart-total]');
				if ( total ) elm.textContent = total.textContent;
			});
		}

		// Republishes the existing DOM event through Shopify's Customer Events
		// pipeline (analytics.publish) so a merchant-configured Custom Pixel can
		// forward it without a theme deploy. Per spec §17, analytics must never
		// block Add to Cart.
		publishAnalytics(name, detail) {
			try {
				window.Shopify?.analytics?.publish(name, detail);
			} catch (_error) {
				// Swallow: a broken or absent pixel must not affect cart submission.
			}
		}

		showCartError(message) {
			const existing = document.getElementById('product-page-form-error-cart-alert');
			if ( existing ) existing.remove();
			const alert = document.createElement('span');
			alert.className = 'alert alert--error';
			alert.id = 'product-page-form-error-cart-alert';
			alert.style.marginTop = '1em';
			alert.style.marginBottom = '0';
			// Shopify 422 responses can carry an object description (e.g. gift-card recipient
			// errors); anything non-string would render "[object Object]".
			alert.textContent = typeof message === 'string' && message !== '' ? message : KROWN.settings.locales.cart_general_error;
			this.form.parentElement.append(alert);
		}

		announceCartUpdate() {
			if ( document.getElementById('screen-reader-info') ) {
				document.getElementById('screen-reader-info').innerText = `${KROWN.settings.locales.cart_announcement}`;
				setTimeout(()=>{
					document.getElementById('screen-reader-info').innerText = '';
				}, 1000);
			}
		}

		_serializeForm(form) {
			let arr = [];
			Array.prototype.slice.call(form.elements).forEach(function(field) {
				if (
					!field.name ||
					field.disabled ||
					['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
				)
					return;
				if (field.type === 'select-multiple') {
					Array.prototype.slice.call(field.options).forEach(function(option) {
						if (!option.selected) return;
						arr.push(
							encodeURIComponent(field.name) +
								'=' +
								encodeURIComponent(option.value)
						);
					});
					return;
				}
				if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
					return;
				arr.push(
					encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
				);
			});
			return arr.join('&');
		}

	}

  if ( typeof customElements.get('product-form') == 'undefined' ) {
		customElements.define('product-form', ProductForm);
	}

}

/* ---
	Product Recommendations
--- */

if ( typeof ProductRecommendations !== 'function' ) {
	class ProductRecommendations extends HTMLElement {

		constructor() {

			super();  

			this._shippingObserver = null;
			this._shippingLocationObserver = null;
			this._shippingLocationObserverTarget = null;
			this._shippingDiscoveryObserver = null;
			this._shippingRunQueued = false;
			this._shippingInFlight = false;
      
      const SUCCESS = new Event('product-recommendations-loaded');
      const FAIL = new Event('product-recommendations-error');

      const handleIntersection = (entries, observer) => {

        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const innerHTML = new DOMParser()
                .parseFromString(text, 'text/html')
                .querySelector('product-recommendations');

							const hasRenderableItems = innerHTML && innerHTML.querySelectorAll('[data-js-product-item], .product-item, [data-js-related-row]').length > 0;
							if ( hasRenderableItems ) {
              this.innerHTML = innerHTML.innerHTML;
              this.querySelectorAll('form').forEach(elm=>{
                if (elm.querySelector('template')) {
                  elm.append(elm.querySelector('template').content.cloneNode(true));
                }
              });
								this.queueShippingAvailabilityRefresh();
              this.dispatchEvent(SUCCESS);
            } else {
							this.dispatchEvent(FAIL);
						}
          })
		  .catch(_e => {
						this.dispatchEvent(FAIL);
          });
      }

			const IntersectionObserverCtor = window.IntersectionObserver;
			if (IntersectionObserverCtor) {
				new IntersectionObserverCtor(handleIntersection.bind(this), {rootMargin: `0px 0px 400px 0px`}).observe(this);
			} else {
				handleIntersection([{ isIntersecting: true }], { unobserve() {} });
			}
			this.initializeShippingAvailabilityObserver();

		}

		disconnectedCallback() {
			if (this._shippingObserver) {
				this._shippingObserver.disconnect();
				this._shippingObserver = null;
			}
			if (this._shippingLocationObserver) {
				this._shippingLocationObserver.disconnect();
				this._shippingLocationObserver = null;
				this._shippingLocationObserverTarget = null;
			}
			if (this._shippingDiscoveryObserver) {
				this._shippingDiscoveryObserver.disconnect();
				this._shippingDiscoveryObserver = null;
			}
		}

		initializeShippingAvailabilityObserver() {
			if (this._shippingObserver) {
				return;
			}

			this._shippingObserver = new MutationObserver((mutations) => {
				const hasRelevantMutation = mutations.some((mutation) => {
					if (mutation.type === 'attributes') {
						const target = mutation.target;
						return !!(
							target &&
							target.nodeType === 1 &&
							target.matches &&
							(
								target.matches('[data-list-shipping-id][data-product-id]') ||
								target.matches('span[data-product-id]')
							)
						);
					}

					if (mutation.type === 'childList') {
						const nodes = [...mutation.addedNodes, ...mutation.removedNodes];
						return nodes.some((node) => {
							if (!node || node.nodeType !== 1 || !node.matches) {
								return false;
							}
							if (
								node.matches('[data-list-shipping-id][data-product-id], span[data-product-id]')
							) {
								return true;
							}
							return !!node.querySelector('[data-list-shipping-id][data-product-id], span[data-product-id]');
						});
					}

					return false;
				});

				if (hasRelevantMutation) {
					this.queueShippingAvailabilityRefresh();
				}
			});

			this._shippingObserver.observe(this, {
				childList: true,
				subtree: true,
				attributes: true,
				attributeFilter: ['data-list-shipping-id', 'data-product-id']
			});

			this.ensureShippingLocationObserver();
			this.ensureShippingNodeDiscoveryObserver();
		}

		ensureShippingNodeDiscoveryObserver() {
			if (this._shippingDiscoveryObserver || !document.body) {
				return;
			}

			const hasRequiredNodes = () => {
				return !!(
					document.querySelector('.shipping-available-location-name[data-location-name]') &&
					document.querySelector('[data-list-shipping-id][data-product-id]') &&
					document.querySelector('span[data-product-id]')
				);
			};

			if (hasRequiredNodes()) {
				return;
			}

			this._shippingDiscoveryObserver = new MutationObserver((mutations) => {
				const hasRelevantInsertions = mutations.some((mutation) => {
					if (mutation.type !== 'childList' || mutation.addedNodes.length === 0) {
						return false;
					}

					return Array.from(mutation.addedNodes).some((node) => {
						if (!node || node.nodeType !== 1 || !node.matches) {
							return false;
						}
						if (node.matches('.shipping-available-location-name[data-location-name], [data-list-shipping-id][data-product-id], span[data-product-id]')) {
							return true;
						}
						return !!node.querySelector('.shipping-available-location-name[data-location-name], [data-list-shipping-id][data-product-id], span[data-product-id]');
					});
				});

				if (!hasRelevantInsertions) {
					return;
				}

				this.ensureShippingLocationObserver();
				this.queueShippingAvailabilityRefresh();

				if (hasRequiredNodes() && this._shippingDiscoveryObserver) {
					this._shippingDiscoveryObserver.disconnect();
					this._shippingDiscoveryObserver = null;
				}
			});

			this._shippingDiscoveryObserver.observe(document.body, {
				childList: true,
				subtree: true
			});
		}

		ensureShippingLocationObserver() {
			const locationNode = document.querySelector('.shipping-available-location-name[data-location-name]');
			if (!locationNode) {
				return;
			}

			if (this._shippingLocationObserverTarget === locationNode && this._shippingLocationObserver) {
				return;
			}

			if (this._shippingLocationObserver) {
				this._shippingLocationObserver.disconnect();
			}

			this._shippingLocationObserverTarget = locationNode;
			this._shippingLocationObserver = new MutationObserver(() => {
				this.queueShippingAvailabilityRefresh();
			});

			this._shippingLocationObserver.observe(locationNode, {
				attributes: true,
				attributeFilter: ['data-location-name']
			});
		}

		queueShippingAvailabilityRefresh() {
			if (this._shippingRunQueued) {
				return;
			}

			this._shippingRunQueued = true;
			Promise.resolve().then(() => {
				this._shippingRunQueued = false;
				this.updateShippingAvailability().catch(() => {});
			});
		}

		async updateShippingAvailability() {
			if (this._shippingInFlight) {
				return;
			}

			this.ensureShippingLocationObserver();

			const locationNode = document.querySelector('.shipping-available-location-name[data-location-name]');
			if (!locationNode) {
				return;
			}

			const locationName = String(locationNode.dataset.locationName || '').trim();
			if (!locationName) {
				return;
			}

			const listNodes = Array.from(document.querySelectorAll('[data-list-shipping-id][data-product-id]'));
			if (listNodes.length === 0) {
				return;
			}

			this._shippingInFlight = true;
			try {
				const availabilityRows = [];
				const listNodeResults = await Promise.all(listNodes.map(async (listNode) => {
					const productId = listNode.dataset.productId;
					const variantIds = String(listNode.dataset.listShippingId || '')
						.split(',')
						.map((id) => id.trim())
						.filter(Boolean);

					if (!productId || variantIds.length === 0) {
						return null;
					}

					const statusNodes = Array.from(document.querySelectorAll(`span[data-product-id="${productId}"]`));
					if (statusNodes.length === 0) {
						return null;
					}

					const signature = `${locationName}::${variantIds.join(',')}`;
					if (statusNodes.every((node) => node.dataset.itgShippingResolvedSig === signature)) {
						return null;
					}

					const locationParts = locationName.split(',').map((part) => part.trim()).filter(Boolean);
					let isAvailable = false;

					const rowResults = await Promise.all(
						variantIds.map(async (variantId) => {
							const fallbackVariantId = Number.parseInt(variantId, 10) || variantId;
							const row = {
								'variant-id': fallbackVariantId,
								available: 'false'
							};

							try {
								const response = await fetch(`/variants/${variantId}/?section_id=helper-pickup-availability-extended`);
								if (typeof response.ok === 'boolean' && !response.ok) {
									return { row, hasLocationMatch: false, hadError: true };
								}
								const text = await response.text();
								const variantNode = new DOMParser()
									.parseFromString(text, 'text/html')
									.querySelector('#variant-availability');

								if (variantNode && variantNode.dataset.variantId) {
									row['variant-id'] = variantNode.dataset.variantId;
								}

								const locationValue = String((variantNode && variantNode.dataset.location) || '');
								const hasLocationMatch = locationParts.some((part) => locationValue.includes(part));
								row.available = hasLocationMatch ? 'true' : 'false';
								return { row, hasLocationMatch, hadError: false };
							} catch {
								return { row, hasLocationMatch: false, hadError: true };
							}
						})
					);

					if (rowResults.some(({ hadError }) => hadError)) {
						return null;
					}

					rowResults.forEach(({ hasLocationMatch }) => {
						if (hasLocationMatch) {
							isAvailable = true;
						}
					});

					return {
						rows: rowResults.map(({ row }) => row),
						statusNodes,
						isAvailable,
						signature
					};
				}));

				listNodeResults.filter(Boolean).forEach((result) => {
					result.rows.forEach((row) => {
						availabilityRows.push(row);
					});

					result.statusNodes.forEach((node) => {
						node.classList.remove('alert--circle-loading', 'alert--note', 'alert--success', 'alert--error', 'unavailable-delivery');
						if (result.isAvailable) {
							node.classList.add('alert--success');
							node.textContent = document.body.dataset.deliverySuccess || 'Available';
						} else {
							node.classList.add('alert--error', 'unavailable-delivery');
							node.textContent = document.body.dataset.deliveryError || 'Unavailable';
						}
						node.dataset.itgShippingResolvedSig = result.signature;
					});
				});

				if (availabilityRows.length > 0) {
					let scriptNode = document.getElementById('itg-item-shipping-availability');
					if (!scriptNode) {
						scriptNode = document.createElement('script');
						scriptNode.id = 'itg-item-shipping-availability';
						document.body.appendChild(scriptNode);
					}

					const serializedRows = JSON.stringify(availabilityRows);
					if (scriptNode.textContent !== serializedRows) {
						scriptNode.textContent = serializedRows;
					}
				}
			} finally {
				this._shippingInFlight = false;
			}
		}

	}
	
  if ( typeof customElements.get('product-recommendations') == 'undefined' ) {
		customElements.define('product-recommendations', ProductRecommendations);
	}

}

/* ---
	Gift card recipent
--- */

if ( typeof GiftCardRecipient !== 'function' ) {

	class GiftCardRecipient extends HTMLElement {

		constructor() {

			super();

			const properties = Array.from(this.querySelectorAll('[name*="properties"]'));
			const checkboxPropertyName = 'properties[__shopify_send_gift_card_to_recipient]';

			this.recipientCheckbox = properties.find(input => input.name === checkboxPropertyName);
			this.recipientOtherProperties = properties.filter(input => input.name !== checkboxPropertyName);
			this.recipientFieldsContainer = this.querySelector('.gift-card-recipient__fields');

			if ( this.recipientCheckbox ) {
				this.recipientCheckbox.addEventListener('change', this.synchronizeProperties.bind(this));
			}
			this.synchronizeProperties();

		}

		synchronizeProperties() {
			this.recipientOtherProperties.forEach(property => property.disabled = !this.recipientCheckbox.checked);
			this.recipientFieldsContainer.classList.toggle('hide', !this.recipientCheckbox.checked);
		}

	}

  if ( typeof customElements.get('gift-card-recipient') == 'undefined' ) {
		customElements.define('gift-card-recipient', GiftCardRecipient);
	}

}

/* ---
	Sticky Add to Cart
--- */

if ( typeof StickyAddToCart !== 'function' ) {
	class StickyAddToCart extends HTMLElement {
		
		constructor() {

			super();  

			const productPage = document.getElementById(this.dataset.id);
			this.hasAttribute('data-append-to') ? document.querySelector(this.dataset.appendTo).appendChild(this) : document.body.appendChild(this);
			
			const productButton = productPage.querySelector('[data-js-product-add-to-cart]');
			const stickyBar = this;
			if ( ! productButton ) return;
			this.observers = [];
			
			// how far the bar intrudes from the viewport bottom — published so fixed
			// widgets pinned to the bottom (e.g. the Gorgias chat launcher) can move
			// out from under it. The bar sits flush at bottom: 0, so its height is
			// the whole intrusion.
			// Measured, not rounded: offsetHeight is an integer, so a bar 247.25px
			// tall published 247px and the sheet stacked on that value sat a quarter
			// pixel low — a hairline of page showing through the join.
			this.measureStickyClearance = () => {
				const height = stickyBar.getBoundingClientRect().height || stickyBar.offsetHeight;
				document.documentElement.style.setProperty('--sticky-add-to-cart-clearance', `${height}px`);
			};

			this.toggleStickyBarOnScroll = () => {
				const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
				const rect = productButton.getBoundingClientRect();
				const isInViewport = (
						rect.top >= 0 &&
						rect.left >= 0 &&
						( rect.bottom - 80 ) <= viewportHeight &&
						rect.right <= (window.innerWidth || document.documentElement.clientWidth)
				);
				// 768 matches the stylesheet's 767px mobile layout breakpoint
				const isMobile = window.innerWidth < 768;
				const shouldShow = isMobile ? ! isInViewport : ( rect.top < 0 || rect.top >= viewportHeight );
				if ( shouldShow === stickyBar.classList.contains('visible') ) return;

				if ( shouldShow ) {
					stickyBar.classList.add('visible');
					document.body.classList.add('sticky-add-to-cart-visible');
					this.measureStickyClearance();
				} else {
					// the sheet is holding the page's own picker, so it has to come back
					// before the bar goes: a sheet left open with no bar under it strands
					// the picker outside the product form
					this.closeVariantSheet?.({ restoreFocus: false });
					stickyBar.classList.remove('visible');
					document.body.classList.remove('sticky-add-to-cart-visible');
				}
			};
			// scroll, resize and orientationchange all fire in bursts, and each one
			// costs a getBoundingClientRect plus a possible clearance re-measure —
			// both layout reads. Coalesce every source into one frame rather than
			// running the toggle per event.
			let stickyResizeFrame = null;
			this.onStickyResize = () => {
				if ( stickyResizeFrame !== null ) return;
				stickyResizeFrame = requestAnimationFrame(() => {
					stickyResizeFrame = null;
					this.toggleStickyBarOnScroll();
					if ( stickyBar.classList.contains('visible') ) this.measureStickyClearance();
					// Whether the item count is shown depends on whether the stepper's
					// numeric readout is visible, and that flips at the 768px breakpoint.
					// Without this, crossing the breakpoint (a rotation, a resized window)
					// leaves the mobile decision in place and the bar prints the same
					// number twice — once in the stepper, once in the button.
					this.invalidateStepperVisibility?.();
					if ( typeof this.syncQuantityUI === 'function' ) this.syncQuantityUI();
				});
			};
			this.cancelStickyResizeFrame = () => {
				if ( stickyResizeFrame !== null ) cancelAnimationFrame(stickyResizeFrame);
				stickyResizeFrame = null;
			};
			window.addEventListener('scroll', this.onStickyResize, { passive: true });
			window.addEventListener('resize', this.onStickyResize, { passive: true });
			window.addEventListener('orientationchange', this.onStickyResize, { passive: true });
			// The primary button moves without any scroll or resize — late images,
			// lazily injected blocks, variant reflows — so the bar would measure a
			// settling layout and stay hidden until the shopper scrolled. (§12.1.3)
			// The bar itself is watched for a different reason: its own height is the
			// clearance other fixed widgets move by, and that changes when the count
			// appears or the row wraps. No feedback loop — the clearance is only ever
			// consumed by a transform on the chat launcher.
			if ( typeof ResizeObserver === 'function' ) {
				const layoutObserver = new ResizeObserver(this.onStickyResize);
				layoutObserver.observe(document.body);
				layoutObserver.observe(productPage);
				layoutObserver.observe(stickyBar);
				this.observers.push(layoutObserver);
			}
			this.toggleStickyBarOnScroll();

			if ( this.hasAttribute('data-single') ) {

				const stickyButton = this.querySelector('button[data-js-atc]');
				const stickyButtonText = this.querySelector('[data-js-atc-text]');
				const productButtonText = productPage.querySelector('[data-js-product-add-to-cart-text]');

				// updateBuyButtons() disables the primary button with a class, not the
				// disabled attribute, and pointer-events does not stop a programmatic
				// click — so the delegation below has to check the state itself.
				const primaryIsUnavailable = () => productButton.hasAttribute('disabled') || productButton.classList.contains('disabled');

				const quantityInput = productPage.querySelector('[data-js-product-quantity] input[name="quantity"]');
				const stickyQty = this.querySelector('[data-js-atc-qty]');

				// assigned below once the quantity UI exists; syncStickyButton owns
				// stickyQty.hidden and stickyButton.disabled, which the quantity UI
				// reads, so it has to re-run the dependent render itself
				this.syncQuantityUI = null;

				const syncStickyButton = () => {
					const unavailable = primaryIsUnavailable();
					stickyButton.disabled = unavailable;
					stickyButton.classList.toggle('disabled', unavailable);
					stickyButton.classList.toggle('working', productButton.classList.contains('working'));
					if ( stickyQty !== null ) stickyQty.hidden = unavailable || quantityInput === null;
					if ( stickyButtonText !== null && productButtonText !== null ) {
						const label = productButtonText.textContent.trim();
						if ( label !== '' ) stickyButtonText.textContent = label;
					}
					if ( this.syncQuantityUI !== null ) this.syncQuantityUI();
				};

				stickyButton.addEventListener('click', ()=>{
					if ( primaryIsUnavailable() ) return;
					// Read synchronously by onSubmitHandler before this call returns,
					// since .click() dispatches the form's submit event in this same
					// call stack (see component-product-form.js onSubmitHandler).
					productPage.dataset.atcSource = 'sticky';
					productButton.click();
					stickyButton.classList.add('working');
				});

				syncStickyButton();
				const stickyButtonObserver = new MutationObserver(syncStickyButton);
				stickyButtonObserver.observe(productButton, {
					attributes: true, attributeFilter: ['class', 'disabled'], childList: true, subtree: true, characterData: true
				});
				this.observers.push(stickyButtonObserver);

				// the sticky stepper drives the main form's quantity input — the input
				// stays the single source of truth for what gets submitted
				let renderStickyQuantity = null;
				if ( stickyQty !== null && quantityInput !== null ) {
					const valueElement = stickyQty.querySelector('[data-js-atc-qty-value]');
					const minusButton = stickyQty.querySelector('[data-js-atc-qty-minus]');
					const plusButton = stickyQty.querySelector('[data-js-atc-qty-plus]');
					const minQuantity = parseInt(quantityInput.getAttribute('min'), 10) || 1;
					const maxQuantity = parseInt(quantityInput.getAttribute('max'), 10) || 999;
					const currentQuantity = () => Math.max(1, parseInt(quantityInput.value, 10) || 1);
					renderStickyQuantity = () => {
						const quantity = currentQuantity();
						valueElement.textContent = quantity;
						// Not disabled at the bounds, matching the product form's own
						// stepper: it stays operable and clamps. Disabling here made the
						// bar's minus grey at quantity 1 while the form's stayed black,
						// and stepQuantity already clamps to min/max either way.
					};
					const stepQuantity = delta => {
						quantityInput.value = Math.min(maxQuantity, Math.max(minQuantity, currentQuantity() + delta));
						// 'change' (not 'input') so the main stepper's own min/max
						// disabled states update through its existing listener
						quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
					};
					minusButton.addEventListener('click', () => stepQuantity(-1));
					plusButton.addEventListener('click', () => stepQuantity(1));
					renderStickyQuantity();
				}

				// count of items one click adds: primary quantity plus any selected
				// related items; hidden at 1 so the default state stays quiet
				const countElement = this.querySelector('[data-js-atc-item-count]');
				if ( countElement !== null || renderStickyQuantity !== null ) {
					// Only the CSS half is cached: getComputedStyle forces a recalc and
					// this runs on every click in the product page, but only a viewport
					// change can flip it, and the resize frame invalidates it. `hidden` is
					// read live — renderStickyQuantity() toggles it with no resize.
					let stepperCssVisible = null;
					const readStepperCssVisible = () => {
						if ( stepperCssVisible !== null ) return stepperCssVisible;
						const stepperNumber = stickyQty !== null
							? stickyQty.querySelector('[data-js-atc-qty-value]')
							: null;
						stepperCssVisible = stepperNumber !== null
							&& window.getComputedStyle(stickyQty).display !== 'none'
							&& window.getComputedStyle(stepperNumber).display !== 'none';
						return stepperCssVisible;
					};
					this.invalidateStepperVisibility = () => { stepperCssVisible = null; };

					const syncQuantityUI = () => {
						if ( renderStickyQuantity !== null ) renderStickyQuantity();
						if ( countElement === null ) return;
						// looked up per sync, never cached: the recommendations block is
						// fetched lazily on intersection, so <product-related> does not
						// exist yet when the bar mounts. Same rule the submit path follows.
						const relatedItems = productPage.querySelector('product-related');
						const primaryQuantity = Math.max(1, parseInt(quantityInput?.value, 10) || 1);
						const addOnCount = typeof relatedItems?.getSelectedItems === 'function'
							? relatedItems.getSelectedItems().reduce((total, item) => total + item.quantity, 0)
							: 0;
						const total = primaryQuantity + addOnCount;

						// Never print the quantity twice: the count is suppressed while the
						// stepper's own number is on screen. Keyed on that number's
						// visibility, not on the group and not on `hidden`, which stays
						// false through a CSS `display: none`.
						const stepperNumberShowing = stickyQty !== null
							&& ! stickyQty.hidden
							&& readStepperCssVisible();
						const repeatsStepper = stepperNumberShowing && total === primaryQuantity;

						countElement.textContent = `(${total})`;
						countElement.hidden = total <= 1 || repeatsStepper || stickyButton.disabled;
					};
					syncQuantityUI();
					this.syncQuantityUI = syncQuantityUI;
					// 'click' catches the main form's quantity steppers, which set the
					// input value without firing input/change; by the time the click
					// bubbles here the new value is in place
					this.quantityUIListener = {
						target: productPage,
						types: ['input', 'change', 'click', 'pdp-product-related-change'],
						handler: syncQuantityUI
					};
					this.quantityUIListener.types.forEach(type => productPage.addEventListener(type, syncQuantityUI));
				}

				if ( productPage.classList.contains('variant-selected') ) {
					this.classList.add('variant-selected');
				} else {
					const variantObserver = new MutationObserver(()=>{
						if ( productPage.classList.contains('variant-selected') ) {
							this.classList.add('variant-selected');
						} else {
							this.classList.remove('variant-selected');
						}
					});
					variantObserver.observe(productPage, {
						attributes: true, childList: false, subtree: false
					});
					this.observers.push(variantObserver);
				}

				// when there are multiple variants

				if ( this.hasAttribute('data-single-with-options') ) {
					const buttonPrice = this.querySelector('[data-js-atc-button-price]');
					const productPrice = productPage.querySelector('[data-update-block="price-sticky-main"]');
					// The button shows the price inline, so it needs the current price
					// alone — not the visually-hidden labels, compare-at price, or saving
					// that the full product-price render also carries.
					const readButtonPrice = () => {
						// When default_to_first_variant is false the block renders both a
						// selected-variant price and a not-yet-selected one; pick the same
						// branch the CSS shows.
						const branch = productPage.classList.contains('variant-selected') ? '.show-block-if-variant-selected' : '.show-block-if-variant-not-selected-yet';
						const scope = productPrice.querySelector(branch) || productPrice;
						const source = scope.querySelector('.product-price--original') || scope;
						const clone = source.cloneNode(true);
						clone.querySelectorAll('.visually-hidden').forEach(node => node.remove());
						return clone.textContent.replace(/\s+/g, ' ').trim();
					};
					// The server renders this price with money_with_currency, so it
					// arrives as "$349.00 CAD". The options app recomputes the total
					// when an attachment is picked and writes it back with the
					// without-currency format, so the button read "$420.99" with no
					// currency as the shopper ticked boxes.
					//
					// The suffix is drawn, not written back. The app keeps the span at
					// its own value, so writing " CAD" into it made the two of us
					// alternate forever: every correction was undone and re-triggered
					// within the same task, starving the event loop until the tab
					// stopped responding — ticking one add-on was enough. Publishing
					// the suffix through a custom property that feeds a ::after leaves
					// the text the app owns untouched, so there is nothing to write
					// back, the same reason the " — " separator is generated content.
					//
					// The trailing-uppercase-triplet match is not proof of a currency
					// code — an app could just as easily land on a three-letter word
					// ("NEW", "KIT") right after a price. Trust the match only once,
					// on the first read, which is always the server-rendered value
					// (readButtonPrice's initial call). A later triplet means the span
					// already ends in something the app chose to show, so nothing is
					// appended: overruling it would mean writing the app's own text
					// back, which is the loop above.
					let currencySuffix = '';
					const CURRENCY_SUFFIX = /\s[A-Z]{3}$/;
					const publishCurrencySuffix = () => {
						const text = buttonPrice.textContent.trim();
						const present = text.match(CURRENCY_SUFFIX);
						if ( ! currencySuffix && present ) currencySuffix = present[0];
						const missing = currencySuffix !== '' && text !== '' && present === null;
						const suffix = missing ? currencySuffix : '';
						buttonPrice.style.setProperty('--atc-currency-suffix', missing ? `"${currencySuffix}"` : '""');
						// Generated content's exposure to assistive tech is inconsistent
						// across browser/AT combinations, so the currency is not left to
						// the ::after alone — the accessible name is stated explicitly as
						// real text, the same amount a sighted shopper reads. This also
						// keeps the decorative " — " separator (the other ::before/::after
						// pair on this span) out of the announced name, which is correct:
						// it exists to be seen, not heard.
						if ( text !== '' ) buttonPrice.setAttribute('aria-label', `${text}${suffix}`);
						else buttonPrice.removeAttribute('aria-label');
					};
					const syncPrice = () => {
						// the separator is a CSS ::before, so it survives the options app
						// rewriting this span's contents on builder pages
						buttonPrice.textContent = readButtonPrice();
						publishCurrencySuffix();
						// the same block is replaced on every variant change, so it is
						// also the signal the chip's label needs
						this.syncVariantChip?.();
					};
					if ( buttonPrice !== null && productPrice !== null ) {
						syncPrice();
						const priceObserver = new MutationObserver(()=>{
							syncPrice();
						});
						priceObserver.observe(productPrice, {
							attributes: false, childList: true, subtree: false
						});
						this.observers.push(priceObserver);

						// Registered after priceObserver so the existing observer order is
						// unchanged. On builder templates the options app writes the attachment
						// total straight into this span — price-sticky-main never
						// changes, so syncPrice above never fires for it. Watch the
						// span itself and republish the suffix. This callback writes a
						// style property and never text, so it cannot retrigger itself
						// and the app has nothing to undo.
						const suffixObserver = new MutationObserver(publishCurrencySuffix);
						suffixObserver.observe(buttonPrice, {
							childList: true, characterData: true, subtree: true
						});
						this.observers.push(suffixObserver);
					}
				}

			} 

			// Both the Choose options button and the desktop variant summary do the
			// same thing: put the picker on screen and hand the shopper to it.
			// Focus moves too — scrolling alone leaves a keyboard or screen-reader
			// user somewhere they are not.
			const goToVariantPicker = () => {
				const picker = productPage.querySelector('product-variants');
				// On a linked range the choice is a row of links to sibling products,
				// not a variant picker — <product-variants> holds only the default
				// Title, so aiming at it lands above the control the shopper wants.
				const linkedRange = productPage.querySelector('.itg_pro_variant_main');
				const pickerIsShown = picker !== null && picker.getBoundingClientRect().height > 0;
				const linkedRangeIsShown = linkedRange !== null && linkedRange.getBoundingClientRect().height > 0;
				// a hidden theme picker still marks the right place in the layout, but
				// if there is none, aim at the product form itself
				const target = pickerIsShown && ! linkedRangeIsShown
					? picker
					: ( linkedRangeIsShown ? linkedRange : ( picker || productPage.querySelector('product-form') || productPage ) );
				target.scrollIntoView({behavior: "smooth", block: "center"});
				const firstControl = target.querySelector('select, input:not([type="hidden"]), button, [tabindex]:not([tabindex="-1"])');
				firstControl?.focus({preventScroll: true});
			};
			this.querySelector('button[data-js-choose]')?.addEventListener('click', goToVariantPicker);

			// Variant sheet. Opening it MOVES the page's own <product-variants> in and
			// moves it back on close, a placeholder holding its position. Same element,
			// not a copy — so swatches, stock messaging and every downstream update work
			// as they do in the page, and there is nothing to keep in sync.
			const variantChip = this.querySelector('[data-js-atc-variant]');
			// The sheet lives in the section, not in this element — see the comment
			// on its markup. It is found by id rather than by descent.
			const variantSheet = this.dataset.sheet
				? document.getElementById(this.dataset.sheet)
				: this.querySelector('[data-js-atc-sheet]');
			if ( variantChip !== null ) {

				const chipLabel = variantChip.querySelector('[data-js-atc-variant-label]');
				const sheetSlot = variantSheet !== null ? variantSheet.querySelector('[data-js-atc-sheet-slot]') : null;
				const chooseText = variantChip.dataset.chooseLabel || '';
				// An element, not a comment node: the picker is lifted out of the page
				// flow while it is on loan, and a comment reserves nothing — the page
				// collapsed by the picker's height the instant the sheet opened, so
				// everything below it jumped. Sized from the picker at open time.
				const placeholder = document.createElement('div');
				placeholder.setAttribute('aria-hidden', 'true');
				placeholder.className = 'sticky-add-to-cart__picker-placeholder';
				const holdPickerSpace = (picker) => {
					const box = picker.getBoundingClientRect();
					const styles = window.getComputedStyle(picker);
					placeholder.style.height = `${box.height}px`;
					placeholder.style.marginTop = styles.marginTop;
					placeholder.style.marginBottom = styles.marginBottom;
					// `.remove-empty-space > *:empty` hides childless elements, and a
					// spacer is childless by definition. Inline beats it, and taking the
					// display from the picker keeps the placeholder behaving as what it
					// stands in for.
					const laidOutAs = styles.display;
					placeholder.style.display = ( ! laidOutAs || laidOutAs === 'inline' || laidOutAs === 'none' )
						? 'block'
						: laidOutAs;
				};
				let sheetOpen = false;

				const readSelection = () => {
					const picker = findPicker();
					if ( picker === null ) return null;
					const parts = [...picker.querySelectorAll('[data-js-product-variant]')].map(group => {
						const select = group.querySelector('select');
						if ( select !== null ) return (select.selectedOptions[0]?.textContent || '').trim();
						return (group.querySelector('input[type="radio"]:checked')?.value || '').trim();
					}).filter(Boolean);
					if ( parts.length === 0 ) return null;
					if ( parts.length > 1 ) return parts.join(' · ');
					const groups = picker.querySelectorAll('[data-js-product-variant]');
					const name = (groups[0]?.querySelector('.product-variant__name')?.textContent || '').trim();
					return name !== '' ? `${name}: ${parts[0]}` : parts[0];
				};

				// Same budget the Liquid renders with: past it a truncated product name
				// says nothing, so the chip falls back to the verb and keeps the full
				// selection in title and aria-label.
				this.syncVariantChip = () => {
					const label = readSelection();
					if ( label === null ) return;
					variantChip.title = label;
					variantChip.setAttribute('aria-label', `${chooseText} — ${label}`);
					// the scrolls-to-builder wording wins over the selection readout
					if ( this.applyVariantAffordance?.() ) return;
					chipLabel.textContent = label.length > 34 ? chooseText : label;
				};

				let borrowedPicker = null;
				const closeSheet = ({ restoreFocus = true } = {}) => {
					if ( ! sheetOpen || variantSheet === null ) return;
					sheetOpen = false;
					// the node we moved, not whatever is in the slot now: if the picker
					// were replaced while displaced, re-reading the slot would reinsert
					// an orphan and leave the page with two
					if ( borrowedPicker !== null && placeholder.parentNode !== null ) {
						placeholder.parentNode.insertBefore(borrowedPicker, placeholder);
					}
					borrowedPicker = null;
					placeholder.remove();
					variantSheet.hidden = true;
					variantChip.setAttribute('aria-expanded', 'false');
					if ( restoreFocus ) variantChip.focus({preventScroll: true});
					this.syncVariantChip();
				};
				this.closeVariantSheet = closeSheet;

				// On builder pages an options app hides <product-variants> and draws its
				// own controls, so there is nothing worth borrowing and the chip scrolls
				// to them instead. Keyed on visibility rather than the app's classes, so
				// it covers any add-on that takes the picker over. (§16.2)
				// What the sheet borrows is declared by Liquid, not sniffed here: a
				// linked range lends its row of sibling links, anything else lends
				// <product-variants>. Products carrying BOTH keep the real picker —
				// its options are the ones the bar can actually apply.
				const borrowsLinkedRange = variantChip.dataset.variantSource === 'linked-range';
				const findPicker = () =>
					productPage.querySelector(borrowsLinkedRange ? '.itg_pro_variant_main' : 'product-variants');

				const pickerIsVisible = () => {
					const picker = findPicker();
					if ( picker === null ) return false;
					// The linked row has no [data-js-product-variant] groups to test —
					// it is a row of links — so it answers for itself.
					if ( borrowsLinkedRange ) {
						return window.getComputedStyle(picker).display !== 'none'
							&& picker.getBoundingClientRect().height > 0;
					}
					return [...picker.querySelectorAll('[data-js-product-variant]')]
						.some(group => window.getComputedStyle(group).display !== 'none');
				};
				// A chip that cannot open anything stops looking like it can. Re-evaluated
				// rather than decided once: the app loads after this element upgrades, so
				// at mount the theme's groups are still visible.
				// The mode is declared per template by `sticky_variant_ui`, not inferred.
				// The one runtime check that remains is a guard, not a detector: if a
				// template is set to open the sheet but the page's picker turns out to
				// be hidden — an app took it over — scrolling beats opening an empty
				// panel.
				const linksToOptions = variantChip.dataset.variantUi === 'link';

				this.applyVariantAffordance = () => {
					const scrolls = linksToOptions || ! pickerIsVisible();
					variantChip.classList.toggle('sticky-add-to-cart__variant--scrolls', scrolls);
					if ( scrolls ) {
						chipLabel.textContent = chooseText;
						variantChip.removeAttribute('aria-haspopup');
						variantChip.removeAttribute('aria-expanded');
					} else {
						variantChip.setAttribute('aria-haspopup', 'dialog');
						variantChip.setAttribute('aria-expanded', String(sheetOpen));
					}
					return scrolls;
				};

				const openSheet = () => {
					if ( sheetOpen ) return closeSheet();
					const picker = findPicker();
					if ( picker === null || variantSheet === null || this.applyVariantAffordance() ) {
						goToVariantPicker();
						return;
					}
					sheetOpen = true;
					borrowedPicker = picker;
					// measured before the move, while it is still laid out in the page
					holdPickerSpace(picker);
					picker.parentNode.insertBefore(placeholder, picker);
					sheetSlot.appendChild(picker);
					variantSheet.hidden = false;
					variantChip.setAttribute('aria-expanded', 'true');
					// a[href] included for the linked range, whose choices are links
					// rather than inputs — without it focus skips to the close button
					const first = sheetSlot.querySelector('select, input:not([type="hidden"]), button, a[href], [tabindex]:not([tabindex="-1"])');
					( first || variantSheet.querySelector('[data-js-atc-sheet-close]') )?.focus({preventScroll: true});
				};

				variantChip.addEventListener('click', openSheet);
				variantSheet?.querySelector('[data-js-atc-sheet-close]')?.addEventListener('click', () => closeSheet());

				// picking a value is the point of the sheet, so it dismisses itself —
				// which also keeps the picker displaced for as short a time as possible
				variantSheet?.addEventListener('change', () => closeSheet());

				const onSheetKeydown = (event) => {
					if ( event.key === 'Escape' && sheetOpen ) closeSheet();
				};
				const onDocumentPointer = (event) => {
					if ( ! sheetOpen ) return;
					if ( variantSheet?.contains(event.target) || variantChip.contains(event.target) ) return;
					closeSheet({restoreFocus: false});
				};
				document.addEventListener('keydown', onSheetKeydown);
				document.addEventListener('pointerdown', onDocumentPointer);
				this.teardownVariantSheet = () => {
					document.removeEventListener('keydown', onSheetKeydown);
					document.removeEventListener('pointerdown', onDocumentPointer);
					closeSheet({restoreFocus: false});
				};

				this.applyVariantAffordance();
				this.syncVariantChip();

				// The app hides the picker some time after load, with no event we can
				// listen for, so watch the element itself.
				const pickerNode = findPicker();
				if ( pickerNode !== null && typeof MutationObserver === 'function' ) {
					// coalesced like the resize path: a variant re-render is a burst of
					// mutations and each one would otherwise cost a getComputedStyle per
					// option group
					let affordanceFrame = null;
					const affordanceObserver = new MutationObserver(() => {
						if ( affordanceFrame !== null ) return;
						affordanceFrame = requestAnimationFrame(() => {
							affordanceFrame = null;
							this.applyVariantAffordance();
						});
					});
					affordanceObserver.observe(pickerNode, {
						attributes: true, attributeFilter: ['style', 'class'], childList: true, subtree: true
					});
					this.observers.push(affordanceObserver);
				}
			}

		}

		disconnectedCallback() {
			if ( this.onStickyResize ) {
				window.removeEventListener('scroll', this.onStickyResize);
				window.removeEventListener('resize', this.onStickyResize);
				window.removeEventListener('orientationchange', this.onStickyResize);
			}
			this.cancelStickyResizeFrame?.();
			// put the picker back in the page before this element goes away, or it
			// leaves with the bar and the product form loses its variant controls
			this.teardownVariantSheet?.();
			document.body.classList.remove('sticky-add-to-cart-visible');
			document.documentElement.style.removeProperty('--sticky-add-to-cart-clearance');
			if ( this.quantityUIListener ) {
				const { target, types, handler } = this.quantityUIListener;
				types.forEach(type => target.removeEventListener(type, handler));
			}
			this.observers?.forEach(observer => observer.disconnect());
		}

		// the theme editor calls unmount() on section unload; the element lives on
		// document.body, so it is never removed implicitly with its section —
		// removing it here runs disconnectedCallback and prevents stacked bars
		unmount() {
			this.remove();
		}

	}

  if ( typeof customElements.get('sticky-add-to-cart') == 'undefined' ) {
		customElements.define('sticky-add-to-cart', StickyAddToCart);
	}

}

/* ---
	Pickup Availability Widget
--- */

if ( typeof PickupAvailabilityWidget !== 'function' ) {
	class PickupAvailabilityWidget extends HTMLElement {

		constructor(){
			super();

			if ( this.querySelector('template') ) {

				const pickupSidebar = this.querySelector('template').content.firstElementChild.cloneNode(true);
				pickupSidebar.id = `site-availability-sidebar-${this.dataset.id}`;
				document.body.append(pickupSidebar);

				const openSidebarButton = this.querySelector('.pickup-availability-widget__more');
				openSidebarButton.setAttribute('aria-controls', pickupSidebar.id);
				openSidebarButton.setAttribute('aria-expanded', 'false');
				this.querySelector('[data-js-open-site-availability-sidebar]').addEventListener('keydown', e=>{
					if ( e.keyCode == window.KEYCODES.RETURN ) {
						window.lastFocusedElm = this.querySelector('[data-js-open-site-availability-sidebar]');
						setTimeout(()=>{
							pickupSidebar.querySelector('[data-js-close]').focus();
						}, 50);
					}
				});
				this.querySelector('[data-js-open-site-availability-sidebar]').addEventListener('click', ()=>{
					pickupSidebar.show();
				});

				const observer = new MutationObserver(()=>{
					pickupSidebar.remove();
					observer.disconnect();
				});
				observer.observe(this.parentElement, {
					attributes: false, childList: true, subtree: false
				});

			}

			this.querySelectorAll('.pickup-availability-widget__location-view').forEach(elm=>{
				elm.addEventListener('click', ()=>{
					document.getElementById(`${elm.getAttribute('aria-controls')}`)?.classList.toggle('opened');
					elm.setAttribute('aria-selected', elm.getAttribute('aria-selected') == "true" ? "false" : "true");
				})
			})

		}

	}

  if ( typeof customElements.get('pickup-availability-widget') == 'undefined' ) {
		customElements.define('pickup-availability-widget', PickupAvailabilityWidget);
	}

}
